import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as componentStore from '../component-store'

import * as models from './models'

/** Renders flat DMS hierarchy rows as an expandable, div-based table. */
@ngCore.Component({
  imports: [ds.ellipsisTooltip.Directive, ds.value.Component],
  selector: 'atn-widget-tree-table',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.dms.schema.Feature} */
  private readonly _schemaFeature = ngCore.inject(state.dms.schema.Feature)
  /** @see {@link componentStore.Widget} */
  private readonly _widgetStore = ngCore.inject(
    componentStore.Widget<ents.core.mosaic.Widget.Type.TreeTable>,
  )

  /** Column view data with display names and value metadata resolved. */
  public readonly columnViewModelsSg = ngCore.computed(
    (
      content = this._widgetStore.contentSg(),
      schema = this._schemaFeature.selectors.schema.asSignal(),
    ) => models.Table.getColumnViewModels(content?.columns ?? [], schema),
  )

  /** Visible rows after applying current expansion state. */
  public readonly visibleRowsSg = ngCore.computed(
    (
      content = this._widgetStore.contentSg(),
      columns = this.columnViewModelsSg(),
      expandedRowIds = this._expandedRowIdsSg(),
    ) =>
      models.Table.getVisibleRows(
        content?.rows ?? [],
        columns,
        content?.rootId,
        expandedRowIds,
      ),
  )

  /** Row ids currently expanded in this local tree-table instance. */
  private readonly _expandedRowIdsSg = ngCore.signal<
    ReadonlySet<ents.core.display.Table.Tree.Row.Id>
  >(new Set())

  /** Toggles one row's expanded state. */
  public toggleRowClickHandler(
    event: MouseEvent,
    row: models.Table.VisibleRow,
  ): void {
    event.stopPropagation()

    if (row.rowId === undefined) {
      return
    }

    const rowId = row.rowId

    this._expandedRowIdsSg.update(expandedRowIds => {
      const nextExpandedRowIds = new Set(expandedRowIds)
      if (nextExpandedRowIds.has(rowId)) {
        nextExpandedRowIds.delete(rowId)
      } else {
        nextExpandedRowIds.add(rowId)
      }

      return nextExpandedRowIds
    })
  }
}
